'use strict';

import type { IndNote } from '../../Entities/Ind/IndNote';
import { EntityCollection } from '../EntityCollection';

export class IndNoteCollection extends EntityCollection<IndNote> {}
